import { toast } from "react-toastify";

const messageHelper = ({ type = "success", actionSubject, action, plural }) => {
    toast[type](`The ${actionSubject} ${plural ? "have" : "has" } been successfully ${action}`);
};

export default messageHelper;
